const PATH_SEPARATOR_REGEX = /\s*(?:\/|>|::|\|)\s*/;
const PLACEHOLDER_SEGMENT_REGEX = /^\{[^}]+\}$/;
const GENERIC_MODULE_SEGMENTS = new Set(["api", "v1", "v2", "v3", "me", "browse"]);

export function getRawModuleName(moduleValue: unknown): string {
  return typeof moduleValue === "string" ? moduleValue.trim() : "";
}

export function getModuleDisplayName(moduleValue: unknown): string {
  const raw = getRawModuleName(moduleValue);
  if (!raw) return "";

  const sanitized = raw.replace(/\s+/g, " ");
  const normalizedPath = sanitized.replace(/^[/\\]+|[/\\]+$/g, "");
  const segments = normalizedPath
    .split(PATH_SEPARATOR_REGEX)
    .map((segment) => segment.trim())
    .filter(Boolean);

  if (segments.length <= 1) {
    return sanitized;
  }

  const meaningfulSegments = segments.filter(
    (segment) => !PLACEHOLDER_SEGMENT_REGEX.test(segment),
  );

  if (meaningfulSegments.length === 0) {
    return sanitized;
  }

  const preferredSegment = meaningfulSegments.find(
    (segment) => !GENERIC_MODULE_SEGMENTS.has(segment.toLowerCase()),
  );

  return preferredSegment ?? meaningfulSegments[0];
}
